import script from "./AgentAccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentAccessView.vue?vue&type=script&setup=true&lang=js"

import "./AgentAccessView.vue?vue&type=style&index=0&id=5fde4988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fde4988"]])

export default __exports__